import { useChatSidebarHandlers } from '@/app-shell/layout/Navigation/hooks/useChatSidebarHandlers';
import { useMobilePanel } from '@/app-shell/layout/Navigation/mobile/use-mobile-panel';
import { trackNavV3ButtonClicked } from '@/app-shell/layout/Navigation/nav-v3/nav-v3-analytics';
import { navV3Messages } from '@/app-shell/layout/Navigation/nav-v3/nav-v3.messages';
import { NavItem } from '@/app-shell/layout/Navigation/sidebar/nav-item';
import { Plus } from 'lucide-react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

/**
 * Nav-v3 "+ New chat" action. Agent Home remounts the Home landing and
 * focuses the composer; legacy Chat keeps the shared handler's established
 * base-route behavior.
 *
 * Never active: New chat is an action, not a destination. Home stays the
 * highlighted row because that is the landing New chat opens.
 */
export const NewChatNavItem = () => {
  const intl = useIntl();
  const { handleNewChat } = useChatSidebarHandlers();
  const { dismissMobileSidebar } = useMobilePanel();

  const onClick = useCallback(() => {
    trackNavV3ButtonClicked({ label: 'nav_v3_new_chat' });
    handleNewChat();
    dismissMobileSidebar();
  }, [handleNewChat, dismissMobileSidebar]);

  return (
    <NavItem
      label={intl.formatMessage(navV3Messages.newChat)}
      icon={<Plus />}
      onClick={onClick}
      isActive={false}
      testId="sidebar-link-new-chat"
    />
  );
};
